import styled from 'styled-components';
import { Text, theme } from '@frameio/vapor';

const Pill = styled.div<{
  $compact: boolean;
}>`
  background-color: ${theme.colors.background.interactive.off};
  border-radius: ${theme.spaces[32]};
  font-variant-numeric: tabular-nums;
  height: fit-content;
  padding: ${(p) =>
    p.$compact ? `2px 7px` : `${theme.spaces[4]} ${theme.spaces[8]}`};
  text-align: center;
  user-select: none;
  width: fit-content;
`;

export const VersionCount = ({
  compact = false,
  count,
  withPill = true,
}: {
  compact?: boolean;
  count: number;
  withPill?: boolean;
}) => {
  const countText = (
    <Text
      color="secondary"
      fontWeight="medium"
      variant={compact ? 'caption' : 'secondary'}
    >
      V{count}
    </Text>
  );

  return (
    <>{withPill ? <Pill $compact={compact}>{countText}</Pill> : countText}</>
  );
};
